export const secondsToReadableTime = (seconds: number) => {
   if (seconds < 0 || isNaN(seconds) || seconds === 0) {
      return '0 day'
   }

   const timeUnits = [
      { unit: 'year', seconds: 31536000 },
      { unit: 'month', seconds: 2592000 },
      { unit: 'week', seconds: 604800 },
      { unit: 'day', seconds: 86400 },
      { unit: 'hour', seconds: 3600 },
      { unit: 'min', seconds: 60 },
      { unit: 'sec', seconds: 1 },
   ]

   for (const { unit, seconds: unitSeconds } of timeUnits) {
      if (seconds >= unitSeconds * 0.5) {
         const count = Math.round(seconds / unitSeconds)
         return `${count} ${unit}${count !== 1 ? 's' : ''}`
      }
   }

   return '0 day'
}
